module.exports = __webpack_public_path__ + "img/p2-55.61f91af4.png";